module.exports = __webpack_public_path__ + "static/media/bolso (35).89f79018.jpg";